/**
 * Generated bundle index. Do not edit.
 */
export * from './public_api';
export { WebStorageUtility as ɵa } from './src/utility/webstorage.utility';
//# sourceMappingURL=ngx-store.js.map